<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div class="text-center">
      <p>{{ $t('deleteCommunityRecommend.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteCommunityRecommend">{{ $t('common.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteCommunityRecommend } from '@/api/phone/communityRecommend/communityRecommendApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteCommunityRecommend',
  data() {
    return {
      dialogVisible: false,
      deleteCommunityRecommendInfo: {}
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.deleteCommunityRecommendInfo = { ...params }
    },
    handleClose() {
      this.deleteCommunityRecommendInfo = {}
    },
    async deleteCommunityRecommend() {
      try {
        await deleteCommunityRecommend({
          ...this.deleteCommunityRecommendInfo,
          shopId: getShopId()
        })
        this.$message.success(this.$t('common.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>